<template>
    <dashboard-layout>
        <div class="d-md-flex justify-content-between align-items-center mb-1"><h3 class="mb-0">Mock exams</h3></div>

        <div class="col-lg-8 mb-3">
            <br>
            <p class="mb-0"><b>Mock exams</b> are designed to recreate what you will experience on the day of the exam
                as accurately as possible. As exams increasingly move online we've also recreated the kind of interface
                you'll use.</p>

            <br>
            <p class="mb-0">The questions are hand picked by our editors to reflect the range and weighting of the
                syllabus. </p><br>
            <p class="mb-0">The questions are <b>completely separate</b> from the main question bank and the mock exam
                score will not affect your overall performance data. If you are unable to complete the mock exam in one
                sitting you have the option of <b>saving your progress</b> and completing the exam at a later date. Due
                to the realistic screen format you are not able to take a mock exam using a mobile phone.</p>
        </div>

        <div class="row row-cols-md-2 row-cols-1">
            <div class="col p-2" v-for="item in items?.data" :key="item.id">
                <div class="card shadow border-0  " >
                    <div class="p-4 border-bottom">
                        <div class="d-flex justify-content-between">
                            <h6 class="mb-0 fw-bold">
                                {{ item?.name }}
                            </h6>
                            <router-link :to="{name: 'mock_exams.show', params: {exam_id: item.id}}"
                                         class="text-primary">Start exam <i class="uil uil-arrow-right align-middle"></i></router-link>
                        </div>
                    </div>

                    <div class="p-4"><a href="javascript:void(0)"
                                        class=" feature-primary key-feature d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
<!--                            <div class="icon text-center rounded-circle me-3">-->
<!--                                <i class="ti ti-users"></i>-->
<!--                            </div>-->
                            <div class="flex-1">
                                <h6 class="mb-0 text-dark mb-3">
                                    This mock exam consists of {{ item.questions_count }} questions
                                </h6>
                                        <div v-if="item.result != null">
                                            <div class="badge bg-success w-100 mb-2 text-start">{{ item.result?.total_correct_questions }} correct answers</div>
                                            <div class="badge bg-danger w-100 mb-2 text-start">{{ (item.result?.total_questions ?? 0) - (item.result?.total_correct_questions ?? 0) }} incorrect answers</div>
                                            <div class="progress mb-2">
                                                <div class="progress-bar pt-1" role="progressbar" :style="{ width: item.result?.result + '%' }" :aria-valuenow="item.result?.result" aria-valuemin="0" aria-valuemax="100">
                                                    {{ item.result?.result }}%
                                                </div>
                                            </div>
                                        </div>

                                <small class="text-muted"> {{ item?.duration }} minutes</small>
                            </div>
                        </div>

                    </a></div>
                </div>
            </div>
        </div>

        <Bootstrap5Pagination
            class="mb-0"
            :data="items"
            :limit="2"
            :show-disabled="false"
            :size="'default'"
            :align="'center'"
            @pagination-change-page="getResults"
        />

    </dashboard-layout>
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import DashboardLayout from "../../dashboard-layout.vue";

const toast = useToast();

export default {
    components: {
        DashboardLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            // q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('mock_exams', {
                params: {
                    'page': page,
                    // 'name': this.q.name,
                    // 'duration': this.q.duration,
                    // 'course_id': this.q.course_id
                    'subscribe_id' : this.$route.params?.subscribe_id
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;

                // this.$router.replace({
                //     name: "mock_exams.index",
                //     query: {
                //         'page': page,
                //         'name': this.q.name,
                //         'duration': this.q.duration,
                //         'course_id': this.q.course_id
                //     }
                // });
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
    }
}
</script>
